<script>
export default {
  name: "support-icon",
  props: ["strokeColor"]
};
</script>

<template>
  <svg
    id="support_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_2" data-name="Group 2">
      <path
        id="Path_1395"
        data-name="Path 1395"
        d="M19,17H18a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1h1a2,2,0,0,1,2,2v3A2,2,0,0,1,19,17Z"
        fill="none"
        :stroke="strokeColor ? strokeColor : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1396"
        data-name="Path 1396"
        d="M6,17H5a2,2,0,0,1-2-2V12a2,2,0,0,1,2-2H6a1,1,0,0,1,1,1v5A1,1,0,0,1,6,17Z"
        fill="none"
        :stroke="strokeColor ? strokeColor : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1397"
        data-name="Path 1397"
        d="M18.5,10V9.5A6.5,6.5,0,0,0,12,3h0A6.5,6.5,0,0,0,5.5,9.5V10"
        fill="none"
        :stroke="strokeColor ? strokeColor : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1398"
        data-name="Path 1398"
        d="M12.625,21.25h-1.25A1.25,1.25,0,0,1,10.125,20h0a1.25,1.25,0,0,1,1.25-1.25h1.25A1.25,1.25,0,0,1,13.875,20h0A1.25,1.25,0,0,1,12.625,21.25Z"
        fill="none"
        :stroke="strokeColor ? strokeColor : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1399"
        data-name="Path 1399"
        d="M13.875,20H16a2,2,0,0,0,2-2V17"
        fill="none"
        :stroke="strokeColor ? strokeColor : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
